/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaSubmitAnagraficaPart } from './pratica-submit-anagrafica-part';
import { PraticaSubmitComponentePart } from './pratica-submit-componente-part';


export interface PraticaCittadinoSubmitForm { 
    tipo_pratica_id: string;
    comune_slug?: string;
    anagrafica: PraticaSubmitAnagraficaPart;
    componenti?: Array<PraticaSubmitComponentePart>;
    form_data?: { [key: string]: any; };
}

